import gsap from 'gsap'
import { SplitText } from 'gsap/SplitText'
import { reduceMotion } from '@js/animations/ReducedMotion'
import { createOnceOnEnter } from '@js/animations/scrollTriggerHelper'

export class SplitReveal {
  constructor () {
    this._elements = document.querySelectorAll('[animation-split]')

    if (!this._elements.length) {
      return
    }

    this.init()
  }

  init () {
    this._elements.forEach((el) => {
      if (reduceMotion) {
        el.classList.add('animation-split--active')
        return
      }

      const split = SplitText.create(el, {
        type: 'lines',
        mask: 'lines',
        aria: 'auto',
        onSplit: (self) => {
          // Room for descenders (g, y, p…) inside line masks without extra line gap.
          self.masks.forEach((mask) => {
            mask.style.paddingBottom = '0.2em'
            mask.style.marginBottom = '-0.2em'
          })
        },
      })

      gsap.set(split.lines, { yPercent: 100 })

      createOnceOnEnter({
        trigger: el,
        onEnter: () => {
          gsap.to(split.lines, {
            yPercent: 0,
            duration: 0.8,
            stagger: 0.1,
            ease: 'power3.out',
          })
        },
      })
    })
  }
}
